<template>
  <div class="summary-page">
    <el-row class="summary-page__row">
      <p class="page-form-title">User page</p>
      <p class="page-form-tip">View user details.</p>
      <el-col>
        <div v-if="accountId" class="user-card__account-id">
          <el-tag type="primary" effect="dark"
            ><i class="el-icon-user-solid"></i> AccountId:
            {{ accountId.match(/(\S*)@/)[1] }}</el-tag
          >
        </div>
      </el-col>
    </el-row>

    <el-row class="summary-page__row">
      <el-card>
        <p class="title">Assets List</p>
        <el-table class="transaction-table" :data="wallets" v-if="wallets">
          <el-table-column prop="name" label="AssetId"
            ><template slot-scope="scope">
              {{ scope.row.name.match(/(\S*)#/)[1] }}
            </template>
          </el-table-column>
          <el-table-column prop="amount" label="Balance" />
        </el-table>
      </el-card>
    </el-row>

    <el-row class="summary-page__row">
      <el-card class="transactions-history">
        <p class="title">Transactions History</p>
        <transactions
          currency
          :transactions="transactions"
          :loading="!isReady"
        />
      </el-card>
    </el-row>
  </div>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex'
import Transactions from '@/components/Transactions'

export default {
  name: 'summary-page',

  components: {
    Transactions
  },

  data() {
    return {
      isReady: false
    }
  },

  computed: {
    ...mapState({
      accountId: (state) => state.Account.accountId,
      accountInfo: (state) => state.Account.accountInfo
    }),

    ...mapGetters({
      transactions: 'transfers',
      wallets: 'wallets'
    })
  },

  methods: {
    ...mapActions(['getAllAccountAssetsTransactions'])
  },

  created() {
    this.getAllAccountAssetsTransactions().finally(() => {
      this.isReady = true
    })
  }
}
</script>

<style scoped lang="scss">
.summary-page__row {
  padding: 2rem;
  &:first-child {
    padding-bottom: 1rem;
  }
  .title {
    font-weight: bold;
    margin-bottom: 1rem;
  }
}
</style>
